import { ReactNode } from 'react';
type LeafProps = {
  attributes: Record<string, unknown>;
  children: ReactNode;
  leaf: {
    bold?: boolean;
    italic?: boolean;
    underline?: boolean;
    code?: boolean;
  };
};
export const Leaf = ({
  attributes,
  children,
  leaf
}: LeafProps) => {
  if (leaf?.bold) {
    children = <strong>{children}</strong>;
  }
  if (leaf?.code) {
    children = <code>{children}</code>;
  }
  if (leaf?.italic) {
    children = <em>{children}</em>;
  }
  if (leaf?.underline) {
    children = <u>{children}</u>;
  }
  return <span {...attributes} data-sentry-component="Leaf" data-sentry-source-file="leaf.tsx">{children}</span>; // eslint-disable-line
};